export const DEFAULT_ORDER = [1, 0, 2]

export const LINK_TYPE = {
	HOME: 'home',
	CUSTOM: 'custom',
}
